module.exports = __webpack_public_path__ + "static/img/11-3.2781ed6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/11-3.jpg
// module id = h5h1
// module chunks = 0